export const DEFAULT_WRF = 3.0;
export const DEFAULT_FFL = 16.0;
export const DEFAULT_SLOPE = 0.0;



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/leaflet_80/constants.js